module.exports = __webpack_public_path__ + "static/media/horse.e6c3a737.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/horse.svg
// module id = 484
// module chunks = 0